<template>
  <div class="user-managed">

    <div
      v-loading="tableLoading"
      class="um-main"
    >
      <router-link :to="'/workbench/print/' + $route.params.fid + '?form_id=' + $route.query.form_id + '&yyid='+ $route.query.yyid+'&type=add'">
        <sw-button
          style="margin: 10px"
          icon="su-icon-plus"
          type="primary"
        >打印模板设计</sw-button>
      </router-link>
      <sw-table
        :show-selection="false"
        :table-name="'print-design'"
        :table-data="tableData"
        :table-title="tableTitle"
        :page-sizes="[10,15,20]"
        :total-count="tableCount"
        :page-size="pageSize"
        :has-add-button="false"
        :table-operation="tableOperation"
        @operation-handle="operationHandle"
        @selection-change="selectionChange"
        @size-change="changeSize"
        @change-page="changePage"
        @next-page="changePage"
        @prev-page="changePage"
      >
        <template
          slot="customcolumn"
          slot-scope="scope"
        >
          <span v-if="scope.item.prop=='name'">
            {{ scope.row.name }}
            <span
              v-if="scope.row.isDefaultTpl === 'true'"
              class="remind-mes"
            ><span class="fs-10">默认</span></span>
          </span>
          <span
            v-else
            :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
            class="swTableCell"
          >
            {{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}
          </span>
        </template>
      </sw-table>
    </div>
  </div>
</template>

<script>
// import Divider from '@/views/formflow/components/divider'
import service from '@/utils/service.js'
import '@/views/formflow/css/appflow/basicdata/userManaged.scss'
export default {
  // components: {
  //   Divider
  // },
  data () {
    return {
      tableLoading: false,
      dialogTitle: '',
      dialogIframeVisible: false,
      iframeSrc: '',
      tableData: [],
      tableTitle: [
        { prop: 'name', label: '模板名称', width: '120', sortable: true },
        { prop: 'createTime', label: '创建时间', width: '120', sortable: true }
      ],
      tableOperation: [
        { name: '修改', icon: 'su-icon-edit', operation: 'edit' },
        { name: '查看', icon: 'su-icon-details', operation: 'details' },
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
      ],
      tableCount: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.tableLoading = true
      service.get('/uu/signature/getSignatureList', {
        params: {
          name: '',
          fid: this.$route.params.fid,
          page: this.currentPage,
          limit: this.pageSize
        }
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.map((item, index) => {
          return item
        })
        this.tableCount = res.count
      }).catch(error => {
        this.$swMessage.error(error)
      })
    },
    selectionChange () {

    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    operationHandle (id, operation) {
      switch (operation) {
        case 'edit':
          this.$router.push({ path: '/workbench/print/' + this.$route.params.fid, query: { form_id: this.$route.query.form_id, tplId: id, yyid: this.$route.query.yyid, type: 'edit' } })
          break
        case 'details':
          this.$router.push({ path: '/workbench/print/' + this.$route.params.fid, query: { form_id: this.$route.query.form_id, tplId: id, yyid: this.$route.query.yyid, type: 'details' } })
          break
        case 'delete':
          this.deleteSignatureTpl(id)
          break
        default:
          console.log('detail')
      }
    },
    deleteSignatureTpl (id) {
      this.$swConfirm('确认删除？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return service.post('/uu/signature/deleteSignatureTplById', {
          id: id
        })
      })
        .then(res => {
          this.$swMessage.success(res.msg)
          this.getData()
        }).catch(res => {
          this.$swMessage.error(res.msg)
        })
    }

  }
}
</script>

<style>
.remind-mes {
  display: inline-block;
  width: 30px !important;
  height: 14px !important;
  line-height: 14px;
  text-align: center;
  margin-left: 8px;
  white-space: nowrap;
  background: rgba(51, 148, 225, 1);
  color: rgba(255, 255, 255, 1);
  border-radius: 0px 26px 26px 0px;
}
.fs-10 {
  display: inline-block;
  font-size: 10px;
  -webkit-font-size: 12px;
  -webkit-transform: scale(0.8);
}
</style>
